import { render, staticRenderFns } from "./heartBubble.vue?vue&type=template&id=aa50a7a2&scoped=true&"
import script from "./heartBubble.vue?vue&type=script&lang=js&"
export * from "./heartBubble.vue?vue&type=script&lang=js&"
import style0 from "./heartBubble.vue?vue&type=style&index=0&id=aa50a7a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa50a7a2",
  null
  
)

export default component.exports